export default "__VITE_ASSET__dd7915b3__"